import Utils from 'live/lib/utils'
import { responseHandlerGenerator, errorHandlerGenerator } from '../utils'

const SERVICE_URL_PREFIX = '/services/plugin-mongodb'

function makeURL(qualifier, suffix) {
    let url = SERVICE_URL_PREFIX

    while (url.indexOf('/') === url.length - 1) url = url.substring(0, url.length - 2)

    if (typeof qualifier != 'undefined' && qualifier.length > 0) url += '/' + qualifier

    url += suffix

    return encodeURI(url)
}

const api = {
    getAllCollectionsMappingNames: (qualifier, signal, onSuccess, onError) => {
        const url = makeURL(qualifier, '/collections/names-and-types')
        fetch(url, { signal: signal })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    },

    getAllMappingCollectionsNames: (qualifier, signal, onSuccess, onError) => {
        const url = makeURL(qualifier, '/collections/mappingnames')
        fetch(url, { signal: signal })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    },

    getAllCollectionsStatsFromCache: (qualifier, signal, onSuccess, onError) => {
        const url = `${makeURL(qualifier, '/collections/stats')}`
        fetch(url, { signal: signal })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    },

    getAllCollectionsStats: (qualifier, params, signal, onSuccess, onError) => {
        const url = `${makeURL(qualifier, '/collections')}?${Utils.objectToQueryStr(params)}`
        fetch(url, { signal: signal })
            .then(responseHandlerGenerator(onSuccess, onError, true))
            .catch(errorHandlerGenerator(url))
    },

    deleteCollection: (qualifier, collectionName, onSuccess, onError) => {
        const url = makeURL(qualifier, `/drop/${collectionName}`)

        fetch(url, {
            method: 'POST',
            headers: Utils.fetchDefaults.headers,
            credentials: Utils.fetchDefaults.credentials
        })
            .then(responseHandlerGenerator(onSuccess, onError))
            .catch(errorHandlerGenerator(url))
    },

    setIndexes: (qualifier, params, onSuccess, onError) => {
        const url = makeURL(qualifier, '/indexes')
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: Utils.fetchDefaults.headers,
            credentials: Utils.fetchDefaults.credentials
        })
            .then(responseHandlerGenerator(onSuccess, onError))
            .catch(errorHandlerGenerator(url))
    },

    deleteIndex: (qualifier, params, onSuccess, onError) => {
        const url = makeURL(qualifier, '/indexes/drop')
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: Utils.fetchDefaults.headers,
            credentials: Utils.fetchDefaults.credentials
        })
            .then(responseHandlerGenerator(onSuccess, onError))
            .catch(errorHandlerGenerator(url))
    }
}

export default api
